export default __webpack_public_path__ + "maps-examples-animate-image-layer-thumbnail-480-d2f203d97e7ed5094192d28b4dee4514.png";